<wl-pagination
  [collectionSize]="collectionSize"
  [rotate]="rotate"
  [maxSize]="maxSize"
  [pageSize]="pageSize"
  [page]="(currentPage$ | async) ?? 1"
  (pageChange)="changePage($event)"
></wl-pagination>
